import { require200Status } from "../../utils/response.js";
import { transformWithSpec } from "../../../utils/response.js";
function topupEndpoints(builder) {
  return {
    topup: builder.mutation({
      invalidatesTags: ["funding-tx"],
      query: (body) => ({
        url: `/member/topup`,
        validateStatus: require200Status,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec()
    }),
    uploadProof: builder.mutation({
      query: ({ fundingTxId, file }) => {
        const formData = new FormData();
        formData.append("files", file);
        return {
          url: `/member/topup/${fundingTxId}/proof`,
          method: "POST",
          body: formData,
          formData: true
        };
      },
      transformResponse: transformWithSpec()
    })
  };
}
export {
  topupEndpoints as default
};
